import Vue from 'vue';
import Router from 'vue-router';
import { decodeQuery, encodeQuery } from 'beans-admin-plugin';

Vue.use(Router);

export const routes = [
  {
    path: '/',
    redirect: '/home'
  },
  {
    path: '/login',
    name: 'login',
    component: require('@/views/login').default
  },
  // {
    // path: '/register',
    // name: 'register',
    // component: require('@/views/register').default
  // },
  {
    path: '/password',
    name: 'password',
    component: require('@/views/password').default
  },
  {
    path: '',
    component: require('@/layouts/nav').default,
    props: {
      menus: require('./menu').default
    },
    children: [
      {
        path: '/home',
        name: 'home',
        meta: {
          can: []
        },
        component: require('@/views/home').default,
      },
      {
        path: '/bind_exists_mini_program',
        name: 'bind_exists_mini_program',
        meta: {
          can: []
        },
        component: require('@/views/bind_wechat/exists_mini_program').default,
      },
      {
        path: '/apply_new_mini_program',
        name: 'apply_new_mini_program',
        meta: {
          can: []
        },
        component: require('@/views/bind_wechat/new_mini_program').default,
      },
      {
        path: '/bind_exists_mini_program/cautions',
        name: 'bind_exists_mini_program.cautions',
        meta: {
          can: []
        },
        component: require('@/views/bind_wechat/cautions').default,
      },
      {
        path: '/mini_program_register',
        name: 'mini_program_register',
        meta: {
          can: 'applications.create'
        },
        component: require('@/views/bind_wechat/register').default,
      },
      {
        path: '/403',
        name: '403',
        component: require('@/views/403').default
      },
      {
        path: '/master_ledger',
        name: 'master_ledger',
        meta: {
          can: []
        },
        component: require('@/views/master_ledger').default,
      },
      // 以下代码为generator插入代码的标记，请勿修改或删除
      // Generator route
      ...require('@/views/walk/walk_challenge_winners').route,
      ...require('@/views/walk/challenge_participation_records').route,
      ...require('@/views/walk/challenges').route,
      ...require('@/views/walk/prizes').route,
      ...require('@/views/walk/clubs').route,
      ...require('@/views/user_request/airtimes').route,
      ...require('@/views/user_request/electricities').route,
      ...require('@/views/walk/step_records').route,
      ...require('@/views/walk/heba_participation_records').route,
      ...require('@/views/walk/heba_reward_rule_items').route,
      ...require('@/views/custom_list/index').route,
      ...require('@/views/brands').route,
      ...require('@/views/ticket_redeem_batches').route,
      ...require('@/views/reset_password_applications').route,
      ...require('@/views/tickets').route,
      ...require('@/views/ticket_orders').route,
      ...require('@/views/ticket_kinds').route,
      ...require('@/views/acts_as_taggable_on/tags').route,
      ...require('@/views/ticket_events').route,
      ...require('@/views/live_events').route,
      ...require('@/views/event_history').route,
      ...require('@/views/push_notification_histories').route,
      ...require('@/views/red_packets').route,
      ...require('@/views/red_packet_joga').route,
      ...require('@/views/events').route,
      ...require('@/views/store_owners').route,
      ...require('@/views/merchants').route,
      ...require('@/views/feedbacks').route,
      ...require('@/views/withdrawal_applications').route,
      ...require('@/views/agents').route,
      ...require('@/views/hot_words').route,
      // ...require('@/views/applications').route,
      ...require('@/views/users').route,
      ...require('@/views/admin_users_roles').route,
      ...require('@/views/roles').route,
      ...require('@/views/operation_records').route,
      ...require('@/views/active_storage/blobs').route,
      ...require('@/views/profile/index').route,
      ...require('@/views/profile/change_password').route,
      ...require('@/views/data_analyses/user_portrait').route,
      ...require('@/views/data_analyses/visit_page').route,
      ...require('@/views/data_analyses/visit_distribution').route,
      ...require('@/views/data_analyses/retain_info').route,
      ...require('@/views/data_analyses/visit_trend').route,
      ...require('@/views/banners').route,
      ...require('@/views/custom_pages').route,
      ...require('@/views/pages').route,
      ...require('@/views/transaction_history').route,
      ...require('@/views/sms').route,
      ...require('@/views/places_listing').route,
      ...require('@/views/merchant_catalog').route,
      ...require('@/views/explore_section').route,
      ...require('@/views/user_verifications').route,
      ...require('@/views/client_app_push').route,
      ...require('@/views/agent_app_push').route,
      ...require('@/views/specific_verification_codes').route,
      ...require('@/views/new_store_owners').route,
      ...require('@/views/settings/index.vue').route,
      ...require('@/views/settings/app_version_settings').route,
      ...require('@/views/settings/red_packet_settings.vue').route,
      ...require('@/views/walk/analytics.vue').route,
    ]
  },
  {
    path: '*',
    name: '404',
    component: require('./views/404').default
  }
]

const router = new Router({
  mode: 'history',
  base: process.env.VUE_APP_ROUTER_BASE_URL,
  routes,
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return {
        x: 0,
        y: 0
      }
    }
  },
  parseQuery (query) {
    return decodeQuery(query);
  },
  stringifyQuery (query) {
    return encodeQuery(query);
  }
});

export default router
